export default {
  core: {
    list: {
      next: "下一步",
      previous: "上一步"
    },
    notFoundErrorMessage: "找不到此实体。",
    serverErrorMessage: "服务器上出错。",
    tagline: "高精度区块浏览器",
    tagline2: "",

    networkOptions: {
      eos_mainnet: "联盟链",
      eos_kylin: "联盟链",
      eos_eosio: "联盟链 测试网"
    },
    maintenance: {
      start: "我们目前正在将我们的后端迁移到",
      link: "https://zhongshuwen.com",
      end:
        "来提供最快，最可靠的区块浏览器。 我们希望在接下来的48小时内完成。 对于沿途的任何颠簸，我们深表歉意！"
    },
    newVersionAvailable: "国家级版权交易保护联盟链区块浏览器 发布了新版本",
    refresh: "刷新",
    by: "来自",
    menu: {
      mainTitle: "菜单",
      titles: {
        network: "网络",
        navigation: "查询",
        language: "语言"
      }
    }
  }
}
